export default "__VITE_ASSET__eb90eaa1__"